import { render, staticRenderFns } from "./mizan.vue?vue&type=template&id=c710e10c&"
import script from "./mizan.vue?vue&type=script&lang=js&"
export * from "./mizan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports